import { connect } from 'react-redux';
import { has, reduce, getOr } from 'lodash/fp';
import {
  getIsFetching,
  getOrder,
  getQuery as getGuestsQuery
} from '../../redux/selectors/components/guest-list';
import { getOrderedCustomLists } from '../../redux/selectors/custom-list';
import { getSearchBy } from '../../redux/selectors/components/guest-search';
import { getPaginationQueryOptions } from '../../redux/selectors/components/guest-list/pagination';
import { fetchCustomList } from '../../redux/sagas/custom-list/routines';
import {
  fetchClients as fetchGuests,
  fetchClientByBarcode as fetchGuestByBarcode
} from '../../redux/sagas/client/routines';
import {
  clearCustomList,
  clearGuests,
  guestsOnChangeQuery,
  onSwitchSearchBy
} from '../../redux/actions';
import GuestSearch from '../../components/GuestSearch';
import { getClientColumnsByName } from '../../redux/selectors/client';
import { getShowBarcodeSearch } from '../../redux/Settings/selectors/main';

function mapStateToProps(state, props) {
  const order = getOrder(state);
  const listColumns = getOrderedCustomLists(state);
  const activeColumnsByName = getClientColumnsByName(state);
  const columns = reduce(
    (all, { columnName }) =>
      has(columnName, activeColumnsByName) ? [...all, columnName] : all,
    [],
    listColumns
  );
  const searchBy = getSearchBy(state);
  const searchQuery = getGuestsQuery(state);
  const paginationQuery = getPaginationQueryOptions(state);
  const defaultShowBarcodeSearch = getShowBarcodeSearch(state);

  return {
    ...props,
    columns,
    searchBy,
    searchQuery,
    showBarcodeSearch: getOr(
      defaultShowBarcodeSearch,
      'showBarcodeSearch',
      props
    ),
    paginationQuery: { ...paginationQuery, order },
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch, { type }) {
  return {
    onInit: () => {
      dispatch(clearCustomList());
      dispatch(fetchCustomList({ type }));
    },
    onSearchByColumns: query => {
      dispatch(clearGuests());
      dispatch(fetchGuests({ ...query, page: 1 }));
    },
    onSearchByBarcode: barcode => {
      dispatch(clearGuests());
      dispatch(fetchGuestByBarcode(barcode));
    },
    onReset: () => {
      dispatch(clearGuests());
    },
    onChangeQuery: query => {
      dispatch(guestsOnChangeQuery(query));
    },
    onSwitchSearchBy: searchBy => {
      dispatch(onSwitchSearchBy(searchBy));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestSearch);
